var map = {
	"./icons/mise/add_attachment_medium": 1188,
	"./icons/mise/add_attachment_medium.svg": 1188,
	"./icons/mise/add_attachment_regular": 66087,
	"./icons/mise/add_attachment_regular.svg": 66087,
	"./icons/mise/add_attachment_small": 1238,
	"./icons/mise/add_attachment_small.svg": 1238,
	"./icons/mise/add_comment_medium": 58622,
	"./icons/mise/add_comment_medium.svg": 58622,
	"./icons/mise/add_comment_regular": 3457,
	"./icons/mise/add_comment_regular.svg": 3457,
	"./icons/mise/add_comment_small": 1392,
	"./icons/mise/add_comment_small.svg": 1392,
	"./icons/mise/add_cooksnap_medium": 46437,
	"./icons/mise/add_cooksnap_medium.svg": 46437,
	"./icons/mise/add_cooksnap_regular": 56244,
	"./icons/mise/add_cooksnap_regular.svg": 56244,
	"./icons/mise/add_cooksnap_small": 60301,
	"./icons/mise/add_cooksnap_small.svg": 60301,
	"./icons/mise/add_folder": 67581,
	"./icons/mise/add_folder.svg": 67581,
	"./icons/mise/add_reaction_medium": 55762,
	"./icons/mise/add_reaction_medium.svg": 55762,
	"./icons/mise/add_reaction_regular": 86693,
	"./icons/mise/add_reaction_regular.svg": 86693,
	"./icons/mise/add_reaction_small": 21420,
	"./icons/mise/add_reaction_small.svg": 21420,
	"./icons/mise/add_recipe_medium": 3919,
	"./icons/mise/add_recipe_medium.svg": 3919,
	"./icons/mise/add_recipe_regular": 21910,
	"./icons/mise/add_recipe_regular.svg": 21910,
	"./icons/mise/add_recipe_small": 99607,
	"./icons/mise/add_recipe_small.svg": 99607,
	"./icons/mise/add_tip_medium": 10502,
	"./icons/mise/add_tip_medium.svg": 10502,
	"./icons/mise/add_tip_regular": 12889,
	"./icons/mise/add_tip_regular.svg": 12889,
	"./icons/mise/add_tip_small": 59944,
	"./icons/mise/add_tip_small.svg": 59944,
	"./icons/mise/add_user_medium": 29378,
	"./icons/mise/add_user_medium.svg": 29378,
	"./icons/mise/add_user_regular": 15349,
	"./icons/mise/add_user_regular.svg": 15349,
	"./icons/mise/add_user_small": 39644,
	"./icons/mise/add_user_small.svg": 39644,
	"./icons/mise/added_user_medium": 40033,
	"./icons/mise/added_user_medium.svg": 40033,
	"./icons/mise/added_user_regular": 27040,
	"./icons/mise/added_user_regular.svg": 27040,
	"./icons/mise/added_user_small": 48017,
	"./icons/mise/added_user_small.svg": 48017,
	"./icons/mise/answer_regular": 33078,
	"./icons/mise/answer_regular.svg": 33078,
	"./icons/mise/answer_small": 12727,
	"./icons/mise/answer_small.svg": 12727,
	"./icons/mise/apple": 81755,
	"./icons/mise/apple.svg": 81755,
	"./icons/mise/arrow_down": 63967,
	"./icons/mise/arrow_down.svg": 63967,
	"./icons/mise/arrow_left": 36672,
	"./icons/mise/arrow_left.svg": 36672,
	"./icons/mise/arrow_right": 111,
	"./icons/mise/arrow_right.svg": 111,
	"./icons/mise/arrow_sort": 56507,
	"./icons/mise/arrow_sort.svg": 56507,
	"./icons/mise/arrow_trend_up": 32136,
	"./icons/mise/arrow_trend_up.svg": 32136,
	"./icons/mise/arrow_trend_up_2": 27903,
	"./icons/mise/arrow_trend_up_2.svg": 27903,
	"./icons/mise/arrow_up": 33968,
	"./icons/mise/arrow_up.svg": 33968,
	"./icons/mise/atachment_medium": 92156,
	"./icons/mise/atachment_medium.svg": 92156,
	"./icons/mise/attachment_regular": 20959,
	"./icons/mise/attachment_regular.svg": 20959,
	"./icons/mise/attachment_small": 96654,
	"./icons/mise/attachment_small.svg": 96654,
	"./icons/mise/award_unselected_regular": 68568,
	"./icons/mise/award_unselected_regular.svg": 68568,
	"./icons/mise/bin_medium": 84154,
	"./icons/mise/bin_medium.svg": 84154,
	"./icons/mise/bin_regular": 90365,
	"./icons/mise/bin_regular.svg": 90365,
	"./icons/mise/bookmark_added_filled_medium": 43309,
	"./icons/mise/bookmark_added_filled_medium.svg": 43309,
	"./icons/mise/bookmark_selected_medium": 69163,
	"./icons/mise/bookmark_selected_medium.svg": 69163,
	"./icons/mise/bookmark_selected_regular": 29010,
	"./icons/mise/bookmark_selected_regular.svg": 29010,
	"./icons/mise/bookmark_selected_small": 66763,
	"./icons/mise/bookmark_selected_small.svg": 66763,
	"./icons/mise/bookmark_unselected_medium": 1128,
	"./icons/mise/bookmark_unselected_medium.svg": 1128,
	"./icons/mise/bookmark_unselected_regular": 62811,
	"./icons/mise/bookmark_unselected_regular.svg": 62811,
	"./icons/mise/bookmark_unselected_small": 35410,
	"./icons/mise/bookmark_unselected_small.svg": 35410,
	"./icons/mise/bookmarks": 18052,
	"./icons/mise/bookmarks.svg": 18052,
	"./icons/mise/calorie_fire": 22589,
	"./icons/mise/calorie_fire.svg": 22589,
	"./icons/mise/camera_medium": 81158,
	"./icons/mise/camera_medium.svg": 81158,
	"./icons/mise/camera_regular": 59001,
	"./icons/mise/camera_regular.svg": 59001,
	"./icons/mise/camera_small": 23080,
	"./icons/mise/camera_small.svg": 23080,
	"./icons/mise/chart_unselected": 95764,
	"./icons/mise/chart_unselected.svg": 95764,
	"./icons/mise/check_circle": 22466,
	"./icons/mise/check_circle.svg": 22466,
	"./icons/mise/check_regular": 58678,
	"./icons/mise/check_regular.svg": 58678,
	"./icons/mise/check_small": 68439,
	"./icons/mise/check_small.svg": 68439,
	"./icons/mise/chevron_down": 60237,
	"./icons/mise/chevron_down.svg": 60237,
	"./icons/mise/chevron_left": 82486,
	"./icons/mise/chevron_left.svg": 82486,
	"./icons/mise/chevron_right": 41333,
	"./icons/mise/chevron_right.svg": 41333,
	"./icons/mise/chevron_up": 95442,
	"./icons/mise/chevron_up.svg": 95442,
	"./icons/mise/close_circle_medium": 11216,
	"./icons/mise/close_circle_medium.svg": 11216,
	"./icons/mise/close_circle_regular": 98963,
	"./icons/mise/close_circle_regular.svg": 98963,
	"./icons/mise/close_circle_small": 54122,
	"./icons/mise/close_circle_small.svg": 54122,
	"./icons/mise/close_regular": 55378,
	"./icons/mise/close_regular.svg": 55378,
	"./icons/mise/close_small": 6859,
	"./icons/mise/close_small.svg": 6859,
	"./icons/mise/collection_unselected": 59402,
	"./icons/mise/collection_unselected.svg": 59402,
	"./icons/mise/comment_medium": 34886,
	"./icons/mise/comment_medium.svg": 34886,
	"./icons/mise/comment_regular": 16473,
	"./icons/mise/comment_regular.svg": 16473,
	"./icons/mise/comment_small": 2312,
	"./icons/mise/comment_small.svg": 2312,
	"./icons/mise/cookbook_logo": 72952,
	"./icons/mise/cookbook_logo.svg": 72952,
	"./icons/mise/cookbook_regular": 40891,
	"./icons/mise/cookbook_regular.svg": 40891,
	"./icons/mise/cooksnap": 10365,
	"./icons/mise/cooksnap.svg": 10365,
	"./icons/mise/cooksnap_medium": 66717,
	"./icons/mise/cooksnap_medium.svg": 66717,
	"./icons/mise/cooksnap_regular": 44956,
	"./icons/mise/cooksnap_regular.svg": 44956,
	"./icons/mise/cooksnap_small": 44757,
	"./icons/mise/cooksnap_small.svg": 44757,
	"./icons/mise/copy": 44438,
	"./icons/mise/copy.svg": 44438,
	"./icons/mise/crown": 31626,
	"./icons/mise/crown.svg": 31626,
	"./icons/mise/dana": 42831,
	"./icons/mise/dana.svg": 42831,
	"./icons/mise/double_arrow_left": 57856,
	"./icons/mise/double_arrow_left.svg": 57856,
	"./icons/mise/download": 3925,
	"./icons/mise/download.svg": 3925,
	"./icons/mise/edit": 61469,
	"./icons/mise/edit.svg": 61469,
	"./icons/mise/email_medium": 63491,
	"./icons/mise/email_medium.svg": 63491,
	"./icons/mise/email_regular": 97050,
	"./icons/mise/email_regular.svg": 97050,
	"./icons/mise/email_small": 87955,
	"./icons/mise/email_small.svg": 87955,
	"./icons/mise/expand": 57657,
	"./icons/mise/expand.svg": 57657,
	"./icons/mise/eye_medium": 32302,
	"./icons/mise/eye_medium.svg": 32302,
	"./icons/mise/eye_off_medium": 34908,
	"./icons/mise/eye_off_medium.svg": 34908,
	"./icons/mise/eye_off_regular": 73967,
	"./icons/mise/eye_off_regular.svg": 73967,
	"./icons/mise/eye_off_small": 86750,
	"./icons/mise/eye_off_small.svg": 86750,
	"./icons/mise/eye_regular": 50865,
	"./icons/mise/eye_regular.svg": 50865,
	"./icons/mise/eye_small": 81760,
	"./icons/mise/eye_small.svg": 81760,
	"./icons/mise/facebook": 50029,
	"./icons/mise/facebook.svg": 50029,
	"./icons/mise/filter": 62967,
	"./icons/mise/filter.svg": 62967,
	"./icons/mise/flag": 6711,
	"./icons/mise/flag.svg": 6711,
	"./icons/mise/flipboard": 91680,
	"./icons/mise/flipboard.svg": 91680,
	"./icons/mise/folder": 84997,
	"./icons/mise/folder.svg": 84997,
	"./icons/mise/full_size": 24110,
	"./icons/mise/full_size.svg": 24110,
	"./icons/mise/globe": 20552,
	"./icons/mise/globe.svg": 20552,
	"./icons/mise/go_pay": 91236,
	"./icons/mise/go_pay.svg": 91236,
	"./icons/mise/google": 20852,
	"./icons/mise/google.svg": 20852,
	"./icons/mise/grab_pay": 63428,
	"./icons/mise/grab_pay.svg": 63428,
	"./icons/mise/home_unselected": 15993,
	"./icons/mise/home_unselected.svg": 15993,
	"./icons/mise/instagram_post": 25464,
	"./icons/mise/instagram_post.svg": 25464,
	"./icons/mise/like": 53728,
	"./icons/mise/like.svg": 53728,
	"./icons/mise/like_selected_medium": 82222,
	"./icons/mise/like_selected_medium.svg": 82222,
	"./icons/mise/like_selected_regular": 31441,
	"./icons/mise/like_selected_regular.svg": 31441,
	"./icons/mise/like_selected_small": 72128,
	"./icons/mise/like_selected_small.svg": 72128,
	"./icons/mise/like_unselected_medium": 38881,
	"./icons/mise/like_unselected_medium.svg": 38881,
	"./icons/mise/like_unselected_regular": 52736,
	"./icons/mise/like_unselected_regular.svg": 52736,
	"./icons/mise/like_unselected_small": 70609,
	"./icons/mise/like_unselected_small.svg": 70609,
	"./icons/mise/link": 47045,
	"./icons/mise/link.svg": 47045,
	"./icons/mise/locked_regular": 27438,
	"./icons/mise/locked_regular.svg": 27438,
	"./icons/mise/locked_small": 74319,
	"./icons/mise/locked_small.svg": 74319,
	"./icons/mise/logout_unselected": 91548,
	"./icons/mise/logout_unselected.svg": 91548,
	"./icons/mise/menu": 70756,
	"./icons/mise/menu.svg": 70756,
	"./icons/mise/mini_size": 69552,
	"./icons/mise/mini_size.svg": 69552,
	"./icons/mise/move_bars_medium": 42955,
	"./icons/mise/move_bars_medium.svg": 42955,
	"./icons/mise/move_bars_regular": 85586,
	"./icons/mise/move_bars_regular.svg": 85586,
	"./icons/mise/mymailru": 40541,
	"./icons/mise/mymailru.svg": 40541,
	"./icons/mise/notification_unread_unselected": 74239,
	"./icons/mise/notification_unread_unselected.svg": 74239,
	"./icons/mise/notification_unselected": 96869,
	"./icons/mise/notification_unselected.svg": 96869,
	"./icons/mise/odnoklassniki": 29468,
	"./icons/mise/odnoklassniki.svg": 29468,
	"./icons/mise/overflow_horizontal_medium": 79492,
	"./icons/mise/overflow_horizontal_medium.svg": 79492,
	"./icons/mise/overflow_horizontal_regular": 72615,
	"./icons/mise/overflow_horizontal_regular.svg": 72615,
	"./icons/mise/ovo": 43369,
	"./icons/mise/ovo.svg": 43369,
	"./icons/mise/phone": 63195,
	"./icons/mise/phone.svg": 63195,
	"./icons/mise/pin_regular": 73939,
	"./icons/mise/pin_regular.svg": 73939,
	"./icons/mise/pin_small": 28746,
	"./icons/mise/pin_small.svg": 28746,
	"./icons/mise/pinterest": 21245,
	"./icons/mise/pinterest.svg": 21245,
	"./icons/mise/play": 60387,
	"./icons/mise/play.svg": 60387,
	"./icons/mise/plus_circle": 54828,
	"./icons/mise/plus_circle.svg": 54828,
	"./icons/mise/plus_create_unselected": 54501,
	"./icons/mise/plus_create_unselected.svg": 54501,
	"./icons/mise/plus_medium": 3269,
	"./icons/mise/plus_medium.svg": 3269,
	"./icons/mise/plus_regular": 26196,
	"./icons/mise/plus_regular.svg": 26196,
	"./icons/mise/plus_small": 34893,
	"./icons/mise/plus_small.svg": 34893,
	"./icons/mise/premium": 17364,
	"./icons/mise/premium.svg": 17364,
	"./icons/mise/premium_medium": 12614,
	"./icons/mise/premium_medium.svg": 12614,
	"./icons/mise/premium_rank_1": 59925,
	"./icons/mise/premium_rank_1.svg": 59925,
	"./icons/mise/premium_rank_1_solid": 54157,
	"./icons/mise/premium_rank_1_solid.svg": 54157,
	"./icons/mise/premium_rank_2": 18678,
	"./icons/mise/premium_rank_2.svg": 18678,
	"./icons/mise/premium_rank_3": 5799,
	"./icons/mise/premium_rank_3.svg": 5799,
	"./icons/mise/present": 14958,
	"./icons/mise/present.svg": 14958,
	"./icons/mise/print": 14030,
	"./icons/mise/print.svg": 14030,
	"./icons/mise/push_pin": 62997,
	"./icons/mise/push_pin.svg": 62997,
	"./icons/mise/question": 93941,
	"./icons/mise/question.svg": 93941,
	"./icons/mise/recipe": 42599,
	"./icons/mise/recipe.svg": 42599,
	"./icons/mise/recipe_medium": 81943,
	"./icons/mise/recipe_medium.svg": 81943,
	"./icons/mise/recipe_regular": 38894,
	"./icons/mise/recipe_regular.svg": 38894,
	"./icons/mise/recipe_small": 98543,
	"./icons/mise/recipe_small.svg": 98543,
	"./icons/mise/replies": 1155,
	"./icons/mise/replies.svg": 1155,
	"./icons/mise/search_unselected": 82602,
	"./icons/mise/search_unselected.svg": 82602,
	"./icons/mise/search_unselected_medium": 3100,
	"./icons/mise/search_unselected_medium.svg": 3100,
	"./icons/mise/search_unselected_regular": 94607,
	"./icons/mise/search_unselected_regular.svg": 94607,
	"./icons/mise/search_unselected_small": 35102,
	"./icons/mise/search_unselected_small.svg": 35102,
	"./icons/mise/send": 38847,
	"./icons/mise/send.svg": 38847,
	"./icons/mise/settings_unselected": 39799,
	"./icons/mise/settings_unselected.svg": 39799,
	"./icons/mise/share": 11142,
	"./icons/mise/share.svg": 11142,
	"./icons/mise/shopee_pay": 93068,
	"./icons/mise/shopee_pay.svg": 93068,
	"./icons/mise/smartphone": 26568,
	"./icons/mise/smartphone.svg": 26568,
	"./icons/mise/star_selected": 8371,
	"./icons/mise/star_selected.svg": 8371,
	"./icons/mise/star_unselected": 91214,
	"./icons/mise/star_unselected.svg": 91214,
	"./icons/mise/switch": 75169,
	"./icons/mise/switch.svg": 75169,
	"./icons/mise/telegram": 55028,
	"./icons/mise/telegram.svg": 55028,
	"./icons/mise/tiktok": 91135,
	"./icons/mise/tiktok.svg": 91135,
	"./icons/mise/time_medium": 36384,
	"./icons/mise/time_medium.svg": 36384,
	"./icons/mise/time_regular": 72867,
	"./icons/mise/time_regular.svg": 72867,
	"./icons/mise/time_small": 54778,
	"./icons/mise/time_small.svg": 54778,
	"./icons/mise/tip": 91036,
	"./icons/mise/tip.svg": 91036,
	"./icons/mise/translate": 93041,
	"./icons/mise/translate.svg": 93041,
	"./icons/mise/twitter": 87306,
	"./icons/mise/twitter.svg": 87306,
	"./icons/mise/user": 50800,
	"./icons/mise/user.svg": 50800,
	"./icons/mise/user_medium": 60986,
	"./icons/mise/user_medium.svg": 60986,
	"./icons/mise/user_regular": 32637,
	"./icons/mise/user_regular.svg": 32637,
	"./icons/mise/user_small": 99140,
	"./icons/mise/user_small.svg": 99140,
	"./icons/mise/users": 32403,
	"./icons/mise/users.svg": 32403,
	"./icons/mise/vkontakte": 95156,
	"./icons/mise/vkontakte.svg": 95156,
	"./icons/mise/warning": 55439,
	"./icons/mise/warning.svg": 55439,
	"./icons/mise/wechat": 2863,
	"./icons/mise/wechat.svg": 2863,
	"./icons/mise/whatsapp": 38735,
	"./icons/mise/whatsapp.svg": 38735,
	"./icons/mise/youtube": 70416,
	"./icons/mise/youtube.svg": 70416
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7546;